import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { isPositiveNumber } from "et3-type-guards";
import { fontWeights } from "et3-ui-library";
import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabat101MGeneralStore from "../../../../../stores/khattabat-stores/101m-stores/general-101m-store";
import getKhattabatSelectsStore from "../../../../../stores/khattabat-stores/selects-store";

const KhattabatResultsSelectionBar = withLiteObserverAndTheme(() => {
  const {
    isSelectedAll,
    toggleAllMarksStates,
    selectedCount,
    getMarkedUserIds
  } = getKhattabatSelectsStore();
  const {
    disableEnableMatchConversationDatabase,
    ignoreMatchConversationDatabase
  } = getKhattabat101MGeneralStore();
  const count = selectedCount.get();
  const hasSelection = isPositiveNumber(count);

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
      >
        <FormControlLabel
          label={i18n.get("SELECT_ALL")}
          control={
            <Checkbox
              color="success"
              checked={isSelectedAll("matchResultPage")}
              onChange={() => toggleAllMarksStates("matchResultPage")}
            />
          }
        />
        <Typography fontWeight={fontWeights.semibold} sx={{ mr: "auto" }}>
          {`${i18n.get("COUNT_SELECTED")}: ${count}`}
        </Typography>
        <Button
          variant="contained"
          color="success"
          disabled={!hasSelection}
          onClick={() =>
            disableEnableMatchConversationDatabase({
              matchIDs: getMarkedUserIds(),
              enableAllConversations: true,
              disableAllConversations: false
            })
          }
        >
          {`${i18n.get("ENABLE_SELECTED_1O1M")} (${count})`}
        </Button>
        <Button
          variant="outlined"
          color="error"
          disabled={!hasSelection}
          onClick={() =>
            disableEnableMatchConversationDatabase({
              matchIDs: getMarkedUserIds(),
              enableAllConversations: false,
              disableAllConversations: true
            })
          }
        >
          {`${i18n.get("DISABLE_SELECTED_1O1M")} (${count})`}
        </Button>
        <Button
          variant="outlined"
          color="error"
          disabled={!hasSelection}
          onClick={() =>
            ignoreMatchConversationDatabase({ matchIDs: getMarkedUserIds() })
          }
        >
          {`${i18n.get("IGNORE")} (${count})`}
        </Button>
      </Stack>
    </Paper>
  );
});

export default KhattabatResultsSelectionBar;
